import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { ForgotPasswordService } from 'src/app/services/forgot_password_service.service';
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatFormField, MatLabel, MatError } from "@angular/material/select";
import { MatInput } from "@angular/material/input";
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot_password.component.html',
    styleUrls: ['./forgot_password.component.scss'],
    imports: [MatProgressSpinner, MatFormField, MatLabel, MatError, ReactiveFormsModule, MatInput, MatButtonModule]
})
export class ForgotPasswordComponent {

    forgotPasswordForm = new FormGroup({
        emailAddress: new FormControl('', [Validators.required, Validators.email]),
    });

    loading = false;
    submitted = false;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private forgotPasswordService: ForgotPasswordService,
    ) {  }

    get formControls(): { [p: string]: AbstractControl } {
        return this.forgotPasswordForm.controls;
    }


    onSubmit(): void {
        const emailAddress = this.formControls.emailAddress.value;
        this.loading = true;
        this.forgotPasswordService
            .post([], { emailAddress })
            .subscribe(
                _ => {
                    this.loading = false;
                    this.router.navigate(['login']);
                },
                _ => {
                    this.loading = false;
                    this.router.navigate(['login']);
                });
    }
}
